import React, {useState, memo} from 'react';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import renderCurrentOpenStatus from '../../LocationSelector/utils/renderCurrentOpenStatus';
import WeeklyTimeSlots from '../../../layout/components/WeeklyTimeSlots';
import { Subhead, Caption2, Body, Caption1 } from "../../../components/Typography";
import { PrimaryButton, ButtonRow } from "../../../components/Buttons";
import appConfig from "../../../../app-config";

const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  margin-top: 24px;
  align-items: center;

  @media (max-width: 786px) {
    margin-top: 0;
    padding: 20px;
    z-index: 999;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr auto;
  justify-content: space-between;
  align-items: center;

  :last-child {
    margin-bottom: 20px;
  }
`;

const Label = styled(Body)`
  color: #737a87;
  font-weight: 600;
  align-self: flex-start;
`;

const HoursWrapper = styled(Collapse)`
  grid-column: 2 / -1;
`;

const DesktopButtonRow = styled(ButtonRow)`
  @media (max-width: 786px) {
    display: none;
  }
`;

const ChildLocationDetails = ({ location, handleOrderFromHere }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleHoursClick = (event) => {
    event.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <Wrapper>
      <Row onClick={handleHoursClick}>
        <Label id="LocationDetails-Hours">Hours</Label>
        <Caption1>{renderCurrentOpenStatus(location)}</Caption1>
        <i className={`fal fa-chevron-${isExpanded ? 'down' : 'right'}`} />
        <HoursWrapper in={isExpanded}>
          <WeeklyTimeSlots
            id="LocationDetails-StoreHours"
            title="Store Hours"
            hours={location.hours}
          />
          <WeeklyTimeSlots
            id="LocationDetails-OrderingHours"
            title="Ordering Hours"
            hours={location.ordering_hours}
          />
        </HoursWrapper>
      </Row>
      <Row>
        <Label id="LocationDetails-PhoneLabel">Phone</Label>
        <Caption1>{location.phone}</Caption1>
        <i className="fas fa-phone" />
      </Row>
      <Row>
        <Label id="LocationDetails-AddressLabel">Address</Label>
        <div>
          <Caption1 id="LocationDetails-Location">{location.line1}</Caption1>
          <Caption1>
            {location.city}, {location.state}
          </Caption1>
          <Caption1 id="LocationDetails-Zip">{location.zip}</Caption1>
        </div>
        <i className="fas fa-map-marker-alt" />
      </Row>
      <DesktopButtonRow justifyContent="center">
        {location.is_order_ahead_enabled && (
          <PrimaryButton
            id="LocationDetails-DesktopOrderButton"
            onClick={(e) => handleOrderFromHere(location)}
          >
            Order From Here
          </PrimaryButton>
        )}
      </DesktopButtonRow>
    </Wrapper>
  );
};

export default memo(ChildLocationDetails);
